// 01 · Apertura (v3.3): aurora azul, grilla, barrido, grano, anillos,
// icono, wordmark, "Motor V6.1", tagline, loader y pie. Estado de error
// tras 8 s sin respuesta (lo decide AppShell): anillos y barra se
// detienen, tarjeta .sp-err con reintento manual y automático cada 5 s.
import { Wordmark } from '../ui';

export default function Splash({ error = false, onRetry }) {
  return (
    <div className={`v3sp${error ? ' err' : ''}`} role="status" aria-label="Cargando Edge Elite">
      {!error && <><div className="sp-grid" /><div className="sp-sweep" /><div className="sp-grain" /><div className="sp-ring" /><div className="sp-ring d" /></>}
      <div className="sp-in">
        <svg className="sp-icon" viewBox="0 0 1024 1024" xmlns="http://www.w3.org/2000/svg" aria-label="Icono Edge Elite"><rect width="1024" height="1024" rx="225" fill="#141416" /><path d="M512 176v672" stroke="#FF4D0D" strokeOpacity=".38" strokeWidth="34" strokeLinecap="round" /><circle cx="512" cy="512" r="176" fill="none" stroke="#FF4D0D" strokeOpacity=".38" strokeWidth="34" /><circle cx="512" cy="512" r="72" fill="#FF4D0D" /></svg>
        <Wordmark width={214} dark />
        <p className="tag">Motor V6.1</p>
        {!error && <p className="clm">Mientras el mercado<br />va a ciegas,<br /><em>nosotros calculamos.</em></p>}
      </div>
      {!error && <><div className="sp-load"><i /></div><p className="sp-foot">Cargando señales del día</p></>}
      {error && (
        <div className="sp-err">
          <b>No pudimos conectar con el motor</b>
          <p>Revisa tu conexión. Reintentamos automáticamente en 5 s.</p>
          <button type="button" className="cta" onClick={onRetry}>Reintentar ahora</button>
        </div>
      )}
    </div>
  );
}
